import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    details: null,
    data: null,
    courses: null,
    school: null,
    settings: null,
    deviceToken: null,
    paymentDetails: null,
    loading: true
}
// school, status, role

export const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        updateAccount: (state, action) => {
            state.details = action.payload?.details ? action.payload?.details : state.details
            state.school = action.payload?.school ? action.payload?.school : state.school
            state.data = action.payload?.data ? action.payload?.data : state.data
            state.settings = action.payload?.settings ? action.payload?.settings : state.settings
            state.deviceToken = action.payload?.deviceToken ? action.payload?.deviceToken : state.deviceToken,
                state.paymentDetails = action.payload?.paymentDetails ? action.payload?.paymentDetails : state.paymentDetails,
                console.log('account update to', state)
        },
        updateAccountDetails: (state, action) => {
            console.log('saving account details to redux')
            state.details = action.payload
        },
        updateAccountData: (state, action) => {
            console.log('saving account data to redux')
            state.data = action.payload
        },
        updateAccountCourses: (state, action) => {
            console.log('saving account courses to redux')
            state.data.courses = action.payload
        },
        updateAccountCourseData: (state, action) => {
            console.log(`saving account course data to redux for course ${action.payload.courseId}`)
            const courseData = state.data.courses.find(course => course.id === action.payload.courseId)
            state.data.courses = state.data.courses.map(
                course => course.id === action.payload.courseId ? { ...courseData, ...action.payload.data } : course
            )
        },
        updateAccountSettings: (state, action) => {
            console.log('saving account settings to redux')
            state.settings = action.payload
        },

        updatePaymentDetails: (state, action) => {
            console.log('saving payment details to redux')
            state.paymentDetails = action.payload
            state.loading = false
        },
        updatePaymentDetailsLoading: (state, action) => {
            console.log('updating payment details loading state to', action.payload)
            state.loading = action.payload
        },
        clearAccount: (state) => {
            state.details = null
            state.courses = null
            state.settings = null
            state.deviceToken = null
            state.data = null
            state.paymentDetails = null
        }
    }
});

export const { updateAccount, updateAccountDetails, updateAccountData, updateAccountCourses, updateAccountSettings, clearAccount, updatePaymentDetails, updatePaymentDetailsLoading } = accountSlice.actions;

export default accountSlice.reducer